import { useQuery } from '@tanstack/react-query'
import { apiClient } from '@/shared/api/client'

export interface MyGiftCard {
  id: string
  initialAmount: number
  balanceAmount: number
  currency: string
  status: string
  recipientName: string | null
  recipientEmail: string | null
  expiresAt: string | null
  createdAt: string
}

interface MyGiftCardsResponse {
  success: boolean
  data: MyGiftCard[]
}

export function useMyGiftCards() {
  return useQuery({
    queryKey: ['my-gift-cards'],
    queryFn: async () => {
      const response = await apiClient<MyGiftCardsResponse>(
        '/api/user/gift-cards',
        { initData: 'auto' }
      )
      return response.data
    },
  })
}
